(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Tohumlu rastgele sayı: aynı tarih/şehir hep aynı haritayı verir
  function seeded(str) {
    var h = 2166136261;
    for (var i = 0; i < str.length; i++) { h ^= str.charCodeAt(i); h = Math.imul(h, 16777619); }
    return function () { h += 0x6D2B79F5; var t = h; t = Math.imul(t ^ (t >>> 15), t | 1); t ^= t + Math.imul(t ^ (t >>> 7), t | 61); return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  }

  // Bilinen takımyıldızların basitleştirilmiş şekilleri (0-1 arası koordinat)
  var SHAPES = [
    [[0, .5], [.18, .35], [.38, .4], [.55, .3], [.72, .45], [.9, .38], [1, .55]],                 // Büyük Ayı kepçesi benzeri zincir
    [[.2, 0], [.35, .3], [.5, .5], [.65, .3], [.8, 0], [.5, .5], [.5, 1]],                          // Kuğu / haç
    [[0, 0], [.25, .45], [.5, .2], [.75, .55], [1, .3]],                                            // Kraliçe (W)
    [[.3, 0], [.25, .4], [.5, .5], [.75, .4], [.7, 0], [.5, .5], [.4, 1], [.6, 1]],                 // Avcı benzeri
    [[0, .6], [.3, .3], [.6, .45], [1, .2], [.6, .45], [.7, 1]]                                     // Aslan benzeri
  ];

  // ---- Canlı yıldız alanı (karşılama ve kapanış bandı)
  function starfield(canvas) {
    var ctx = canvas.getContext('2d'); if (!ctx) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2), W, H, stars = [], cons = [], t0 = performance.now(), running = true;
    var rnd = seeded('boniart');
    function resize() {
      var r = canvas.getBoundingClientRect(); W = r.width; H = r.height;
      canvas.width = W * dpr; canvas.height = H * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round(W * H / 2600); stars = [];
      for (var i = 0; i < n; i++) stars.push({ x: rnd() * W, y: rnd() * H, r: rnd() * 1.3 + .2, p: rnd() * Math.PI * 2, s: .5 + rnd() * 1.5 });
      cons = [];
      if (canvas.hasAttribute('data-constellations')) {
        var count = W > 900 ? 4 : 2;
        for (var c = 0; c < count; c++) {
          var sh = SHAPES[c % SHAPES.length], size = Math.min(W, H) * (.18 + rnd() * .1);
          var ox = (c % 2 ? .55 : .05) * W + rnd() * W * .3, oy = (c < 2 ? .08 : .55) * H + rnd() * H * .2;
          cons.push({ pts: sh.map(function (p) { return [ox + p[0] * size, oy + p[1] * size * .8]; }), delay: c * 1.6 });
        }
      }
    }
    function frame(now) {
      if (!running) return;
      var t = (now - t0) / 1000; ctx.clearRect(0, 0, W, H);
      var drift = reduce ? 0 : t * 2;
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i], a = reduce ? .8 : .45 + .55 * Math.abs(Math.sin(s.p + t * s.s * .6));
        var x = (s.x + drift * s.r * .4) % W;
        ctx.globalAlpha = a; ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(x, s.y, s.r, 0, 6.283); ctx.fill();
      }
      // takımyıldız çizgileri: sırayla çizilir, bir süre durur, söner, tekrar başlar
      for (var c = 0; c < cons.length; c++) {
        var cn = cons[c], cyc = 9, lt = ((t - cn.delay) % cyc + cyc) % cyc, prog = reduce ? 1 : Math.min(1, lt / 3), fade = lt > 7 ? 1 - (lt - 7) / 2 : 1;
        if (t < cn.delay && !reduce) continue;
        var segs = cn.pts.length - 1, upto = prog * segs;
        ctx.globalAlpha = .55 * fade; ctx.strokeStyle = 'rgba(255,255,255,.7)'; ctx.lineWidth = 1; ctx.beginPath(); ctx.moveTo(cn.pts[0][0], cn.pts[0][1]);
        for (var k = 1; k <= segs; k++) {
          var a0 = cn.pts[k - 1], a1 = cn.pts[k], f = Math.max(0, Math.min(1, upto - (k - 1)));
          if (f <= 0) break; ctx.lineTo(a0[0] + (a1[0] - a0[0]) * f, a0[1] + (a1[1] - a0[1]) * f);
        }
        ctx.stroke();
        for (var q = 0; q < cn.pts.length; q++) {
          if (q > upto + .01) break;
          ctx.globalAlpha = .95 * fade; ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(cn.pts[q][0], cn.pts[q][1], 2.1, 0, 6.283); ctx.fill();
          ctx.globalAlpha = .25 * fade; ctx.beginPath(); ctx.arc(cn.pts[q][0], cn.pts[q][1], 6, 0, 6.283); ctx.fill();
        }
      }
      ctx.globalAlpha = 1;
      if (!reduce) requestAnimationFrame(frame);
    }
    resize(); requestAnimationFrame(frame);
    var to; window.addEventListener('resize', function () { clearTimeout(to); to = setTimeout(resize, 200); });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (e) {
      var vis = e[0].isIntersecting; if (vis && !running) { running = true; requestAnimationFrame(frame); } running = vis;
    }).observe(canvas);
  }
  document.querySelectorAll('[data-starfield]').forEach(starfield);

  // ---- Karşılamada dönen ürün görselleri
  document.querySelectorAll('[data-rotator]').forEach(function (box) {
    var imgs = box.querySelectorAll('img'); if (!imgs.length) return;
    var dots = box.parentElement.querySelector('[data-rotator-dots]'), i = 0, timer;
    function show(n) {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.style.opacity = k === i ? '1' : '0'; });
      if (dots) dots.querySelectorAll('button').forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
    }
    if (dots && imgs.length > 1) imgs.forEach(function (_, k) {
      var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Görsel ' + (k + 1));
      b.addEventListener('click', function () { show(k); clearInterval(timer); timer = setInterval(function () { show(i + 1); }, 3800); });
      dots.appendChild(b);
    });
    show(0);
    if (imgs.length > 1 && !reduce) timer = setInterval(function () { show(i + 1); }, 3800);
  });

  // ---- Kaydırınca belirme + sayaçlar
  function countUp(el) {
    var end = parseFloat(el.getAttribute('data-count')) || 0, dur = 1400, st = performance.now();
    var fmt = function (n) { return Math.round(n).toLocaleString('tr-TR'); };
    if (reduce) { el.textContent = fmt(end); return; }
    (function step(now) { var p = Math.min(1, (now - st) / dur), e = 1 - Math.pow(1 - p, 3); el.textContent = fmt(end * e); if (p < 1) requestAnimationFrame(step); })(st);
  }
  var reveals = document.querySelectorAll('[data-reveal], .stat, .track3');
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        en.target.classList.add('is-in');
        en.target.querySelectorAll('[data-count]').forEach(countUp);
        io.unobserve(en.target);
      });
    }, { threshold: .15, rootMargin: '0px 0px -40px 0px' });
    reveals.forEach(function (el) { io.observe(el); });
  } else reveals.forEach(function (el) { el.classList.add('is-in'); });

  // ---- Canlı deneme posteri
  var AYLAR = ['OCAK', 'ŞUBAT', 'MART', 'NİSAN', 'MAYIS', 'HAZİRAN', 'TEMMUZ', 'AĞUSTOS', 'EYLÜL', 'EKİM', 'KASIM', 'ARALIK'];
  document.querySelectorAll('[data-demo]').forEach(function (form) {
    var sec = form.closest('section'), poster = sec.querySelector('[data-poster]');
    var bgs = poster.querySelectorAll('.rposter__bg'), dbtn = sec.querySelectorAll('[data-demo-design]'), cta = sec.querySelector('[data-demo-cta]');
    function val(k) { var el = form.querySelector('[data-demo-in="' + k + '"]'); return el ? (el.type === 'checkbox' ? el.checked : el.value) : ''; }
    function out(k) { return poster.querySelector('[data-out="' + k + '"]'); }
    function layout(i) {
      bgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
      dbtn.forEach(function (b, k) { b.classList.toggle('is-on', k === i); });
      var l = (bgs[i] && bgs[i].dataset.l || '18,73.7,80.2,88').split(',');
      ['top', 'sub', 'names', 'meta'].forEach(function (k, j) { out(k).style.top = l[j] + '%'; });
      if (cta && dbtn[i] && dbtn[i].dataset.url) cta.href = dbtn[i].dataset.url;
    }
    dbtn.forEach(function (b, k) { b.addEventListener('click', function () { var im = bgs[k]; if (im && im.loading === 'lazy') im.loading = 'eager'; layout(k); }); });
    function render() {
      var d = val('date'), tm = val('time'), city = val('city');
      out('top').textContent = (val('top') || '').toLocaleUpperCase('tr-TR');
      out('names').textContent = val('names');
      var when = '';
      if (d) { var p = d.split('-'); when = p[2] + '.' + p[1] + '.' + p[0]; }
      if (tm) when += (when ? ' - ' : '') + tm;
      out('when').textContent = when;
      out('city').textContent = (city || '').toLocaleUpperCase('tr-TR');
    }
    form.addEventListener('input', render); form.addEventListener('change', render); layout(0); render();
  });

  // ---- Ürün sayfası: geçişli mesajlar
  document.querySelectorAll('[data-ticker]').forEach(function (t) {
    var items = t.querySelectorAll('.ticker__item'), i = 0; if (!items.length) return;
    items[0].classList.add('is-on'); if (items.length < 2 || reduce) return;
    setInterval(function () {
      var cur = items[i]; cur.classList.remove('is-on'); cur.classList.add('is-out');
      i = (i + 1) % items.length; var nx = items[i]; nx.classList.remove('is-out'); void nx.offsetWidth; nx.classList.add('is-on');
      setTimeout(function () { cur.classList.remove('is-out'); }, 600);
    }, 3200);
  });

  // ---- Canlı forma: kulüp renkleri, isim ve numara; boşta kendi kendine örnek döner
  document.querySelectorAll('[data-jersey]').forEach(function (form) {
    var sec = form.closest('section'), svg = sec.querySelector('.jd__shirt');
    var nameIn = form.querySelector('[data-jd-in="name"]'), numIn = form.querySelector('[data-jd-in="num"]');
    var outName = sec.querySelector('[data-jd-out="name"]'), outNum = sec.querySelector('[data-jd-out="num"]'), outClub = sec.querySelector('[data-jd-out="club"]');
    var clubs = form.querySelectorAll('.jd__club'), go = form.querySelector('[data-jd-go]'), touched = false, k = 0;
    var SAMPLES = [['MEHMET', '10'], ['AYŞE', '7'], ['BABA', '1'], ['EFE', '23'], ['ZEYNEP', '9'], ['KAPTAN', '4']];
    function paint(btn) {
      var c1 = btn.dataset.c1, c2 = btn.dataset.c2, st = btn.dataset.style;
      svg.querySelectorAll('[data-jd="c1"]').forEach(function (e) { e.setAttribute('fill', c1); });
      svg.querySelectorAll('[data-jd="c2"]').forEach(function (e) { e.setAttribute('fill', c2); });
      svg.querySelector('[data-jd="c2s"]').setAttribute('stroke', c2);
      svg.querySelector('[data-jd="stripes"]').setAttribute('opacity', st === 'stripes' ? '1' : '0');
      svg.querySelector('[data-jd-half]').setAttribute('opacity', st === 'half' ? '1' : '0');
      var light = /^#?(f|e|d)/i.test(c1.replace('#', '')) && st !== 'stripes';
      [outName, outNum].forEach(function (t) { t.style.fill = light ? '#111' : '#fff'; });
      clubs.forEach(function (b) { b.classList.toggle('is-on', b === btn); });
      outClub.textContent = btn.dataset.label;
      if (go && btn.dataset.url) go.href = btn.dataset.url;
    }
    function text() {
      outName.textContent = (nameIn.value || SAMPLES[k][0]).toLocaleUpperCase('tr-TR');
      outNum.textContent = (numIn.value.replace(/\D/g, '') || SAMPLES[k][1]);
    }
    clubs.forEach(function (b) { b.addEventListener('click', function () { touched = true; paint(b); }); });
    form.addEventListener('input', function () { touched = true; text(); });
    if (clubs.length) paint(clubs[0]); text();
    if (!reduce) setInterval(function () {
      if (touched) return;
      k = (k + 1) % SAMPLES.length; text();
      if (clubs.length) paint(clubs[k % clubs.length]);
    }, 2600);
  });

  // ---- Yorumlar: ilk N tanesi, düğmeyle hepsi
  document.querySelectorAll('[data-revs]').forEach(function (g) {
    var n = parseInt(g.getAttribute('data-initial'), 10) || 6, items = g.querySelectorAll('.rev'), more = g.parentElement.querySelector('[data-revs-more]');
    if (items.length <= n) { if (more) more.hidden = true; return; }
    items.forEach(function (it, k) { if (k >= n) it.hidden = true; });
    if (more) more.addEventListener('click', function () { items.forEach(function (it) { it.hidden = false; it.classList.add('is-in'); }); more.hidden = true; });
  });

  // ---- Takım vitrini: gerçek tasarımlar arasında otomatik geçiş + seçim (+ takıma göre arka planlar)
  document.querySelectorAll('[data-showcase]').forEach(function (sec) {
    var imgs = sec.querySelectorAll('.showc__img'), btns = sec.querySelectorAll('[data-showc-go]'), lab = sec.querySelector('[data-showc-label]');
    var bar = sec.querySelector('[data-showc-bar]'), cta = sec.querySelector('[data-showc-cta]'), baseHref = cta ? cta.getAttribute('href') : '';
    var bgWrap = sec.querySelector('[data-showc-bgs]'), bgTeam = sec.querySelector('[data-showc-bgteam]'), bgBtns = sec.querySelectorAll('[data-bg-team]');
    var i = 0, DUR = 3200, t0 = performance.now(), paused = false, labels = [], seq = [];
    btns.forEach(function (b) { labels[+b.dataset.showcGo] = b.textContent.trim(); });
    imgs.forEach(function (im, k) { if (im.dataset.type !== 'bg') seq.push(k); });
    function syncBgs(team) {
      if (!bgWrap) return; var any = false;
      bgBtns.forEach(function (b) { var on = b.dataset.bgTeam === team; b.hidden = !on; if (on) { any = true; var im = b.querySelector('img'); if (im && im.loading === 'lazy') im.loading = 'eager'; } });
      bgWrap.hidden = !any; if (bgTeam) bgTeam.textContent = any ? '· ' + team : '';
    }
    function show(n, manual) {
      i = (n + imgs.length) % imgs.length;
      imgs.forEach(function (im, k) { im.classList.toggle('is-on', k === i); });
      var cur = imgs[i], team = cur.dataset.team || '';
      btns.forEach(function (b) {
        var k = +b.dataset.showcGo, t = imgs[k] && imgs[k].dataset.type;
        b.classList.toggle('is-on', k === i || (t === 'team' && cur.dataset.type === 'bg' && imgs[k].dataset.team === team));
      });
      syncBgs(team);
      var act = sec.querySelector('.jd__clubs--scroll .jd__club.is-on');
      if (act) { var row = act.parentElement; if (row.scrollWidth > row.clientWidth) { var r = act.getBoundingClientRect(), rr = row.getBoundingClientRect(); if (r.left < rr.left || r.right > rr.right) row.scrollTo({ left: row.scrollLeft + (r.left - rr.left) - 16, behavior: 'smooth' }); } }
      if (lab && labels[i]) lab.textContent = cur.dataset.type === 'bg' ? team + ' · ' + labels[i] : labels[i];
      var b = sec.querySelector('[data-showc-go="' + i + '"]'); if (cta) cta.href = (b && b.dataset.url) || baseHref;
      t0 = performance.now(); if (manual) paused = true;
      var p = seq.indexOf(i), nx = imgs[seq[(p + 1) % seq.length]]; if (nx && nx.loading === 'lazy') nx.loading = 'eager';
    }
    btns.forEach(function (b) { b.addEventListener('click', function () { var k = +b.dataset.showcGo; if (imgs[k].loading === 'lazy') imgs[k].loading = 'eager'; show(k, true); }); });
    syncBgs(imgs[0] ? imgs[0].dataset.team : '');
    if (reduce || seq.length < 2) return;
    (function tick(now) {
      var p = Math.min(1, (now - t0) / (paused ? DUR * 3 : DUR));
      if (bar) bar.style.width = (p * 100) + '%';
      if (p >= 1) {
        paused = false;
        var cur = imgs[i];
        if (cur.dataset.type === 'bg') {   // arka plan seçiliyken aynı takımın diğer arka planlarında dolaş
          var same = [].filter.call(imgs, function (im) { return im.dataset.type === 'bg' && im.dataset.team === cur.dataset.team; });
          var j = same.indexOf(cur); show([].indexOf.call(imgs, same[(j + 1) % same.length]));
        } else { var q = seq.indexOf(i); show(seq[(q + 1) % seq.length]); }
      }
      requestAnimationFrame(tick);
    })(t0);
  });

  // ---- Tasarım duvarı: ilk N tanesini göster, düğmeyle hepsini aç
  document.querySelectorAll('[data-designs]').forEach(function (wall) {
    var n = parseInt(wall.getAttribute('data-initial'), 10) || 8, items = wall.querySelectorAll('.design');
    var more = wall.parentElement.querySelector('[data-designs-more]'), all = wall.parentElement.querySelector('[data-designs-all]');
    if (window.matchMedia('(max-width: 749px)').matches) { if (more) more.hidden = true; if (all) all.hidden = false; return; }
    if (items.length <= n) { if (more) more.hidden = true; if (all) all.hidden = false; return; }
    items.forEach(function (it, k) { if (k >= n) it.hidden = true; });
    if (more) more.addEventListener('click', function () {
      items.forEach(function (it) { it.hidden = false; it.classList.add('is-in'); });
      more.hidden = true; if (all) all.hidden = false;
    });
  });
})();

/* reels: lazy video src + play only in view */
(function(){var vs=document.querySelectorAll('.reel__video[data-src]');if(!vs.length||!('IntersectionObserver' in window))return;
var io=new IntersectionObserver(function(es){es.forEach(function(e){var v=e.target;if(e.isIntersecting){if(!v.getAttribute('src')){v.src=v.dataset.src;}var p=v.play();if(p&&p.catch)p.catch(function(){});}else{v.pause();}});},{rootMargin:'200px 200px'});
vs.forEach(function(v){io.observe(v);});})();

/* karşılama: yazılan kelime */
(function(){document.querySelectorAll('[data-typer]').forEach(function(el){
  var words=(el.dataset.words||'').split(',').map(function(w){return w.trim();}).filter(Boolean); if(words.length<2)return;
  if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  var wi=0,ci=words[0].length,del=true;
  function tick(){var w=words[wi];
    if(del){ci--; el.textContent=w.slice(0,ci); if(ci<=0){del=false;wi=(wi+1)%words.length;} setTimeout(tick,45);}
    else{var n=words[wi]; ci++; el.textContent=n.slice(0,ci); if(ci>=n.length){del=true; setTimeout(tick,1800);} else setTimeout(tick,85);}
  }
  el.textContent=words[0]; setTimeout(tick,1800);
});})();

/* ürün tipleri: koleksiyondaki ürünler sırayla */
(function(){document.querySelectorAll('[data-fmt-rot]').forEach(function(box){
  var sl=box.querySelectorAll('.fmt__slide'), cap=box.querySelector('[data-fmt-cap]'), i=0; if(!sl.length)return;
  function show(n){sl[i].classList.remove('is-on'); i=n%sl.length; sl[i].classList.add('is-on'); if(cap)cap.textContent=sl[i].dataset.name||''; var nx=sl[(i+1)%sl.length].querySelector('img'); if(nx&&nx.loading==='lazy')nx.loading='eager';}
  if(cap)cap.textContent=sl[0].dataset.name||'';
  if(sl.length<2||window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;
  setTimeout(function(){setInterval(function(){show(i+1);},3000);},+box.dataset.delay||0);
});})();
/* Ürün sayfası sayaçları: görünür olunca sıfırdan sayar */
(function(){
  var box=document.querySelector('[data-pstats]'); if(!box) return;
  var go=function(){ box.querySelectorAll('[data-count]').forEach(function(el){
    var end=+el.dataset.count, t0=null, dur=1400;
    function step(t){ if(!t0) t0=t; var k=Math.min(1,(t-t0)/dur), v=Math.round(end*(1-Math.pow(1-k,3)));
      el.textContent=v.toLocaleString('tr-TR'); if(k<1) requestAnimationFrame(step); }
    requestAnimationFrame(step); }); };
  if('IntersectionObserver' in window){ var io=new IntersectionObserver(function(e){ if(e[0].isIntersecting){ io.disconnect(); go(); } }); io.observe(box); } else go();
})();
/* video kartı: ses aç/kapa (kart bağlantısına gitmez) */
document.addEventListener('click',function(e){var b=e.target.closest('[data-reel-snd]');if(!b)return;e.preventDefault();e.stopPropagation();
  var v=b.closest('.reel').querySelector('video');if(!v)return;if(!v.getAttribute('src')&&v.dataset.src)v.src=v.dataset.src;
  var on=v.muted;document.querySelectorAll('.reel video').forEach(function(o){if(o!==v){o.muted=true;var ob=o.closest('.reel').querySelector('[data-reel-snd]');if(ob){ob.classList.remove('is-on');ob.setAttribute('aria-pressed','false');ob.setAttribute('aria-label','Sesi aç');}}});
  v.muted=!on;b.classList.toggle('is-on',on);b.setAttribute('aria-pressed',on?'true':'false');b.setAttribute('aria-label',on?'Sesi kapat':'Sesi aç');var p=v.play();if(p&&p.catch)p.catch(function(){});},true);
